"use client";
import React, { useState } from "react";
import style from "@/app/style/state.module.css";
import { CiSearch } from "react-icons/ci";

function Header({ onSearch }) {
  const [searchTerm, setSearchTerm] = useState("");

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
    onSearch(event.target.value); // Call the onSearch callback with the search term
  };

  const home = [
    {
      image: "airportsPagemain",
    },
  ];

  return (
    <div>
      <div className="mx-auto max-w-7xl headerpxset">
        {home.map((object) => (
          <div
            key={object.image}
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "center",
              paddingBottom: "50px",
            }}
            className={style[object.image]}
          >
            <div className="relative mt-2 rounded-md shadow-sm lg:w-3/6 w-4/5 mb-9">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <CiSearch className="h-5 w-5" aria-hidden="true" />
              </div>
              <input
                type="text"
                name="search"
                id="search"
                className="block w-full  citylocation"
                placeholder="Find airport ..."
                value={searchTerm}
                onChange={handleChange}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Header;
